<template>
  <HMButton :color="color" @click="openTipModal">
    <div class="d-flex align-items-baseline justify-content-center">
      <i class="far fa-heart mr-2" :class="color"></i>
      <span>{{ $t('STUDIO.BUTTON.LEAVE_A_TIP') }}</span>
    </div>
  </HMButton>
</template>

<script>
import TipJarModal from '@/web/components/settings/TipJarModal';
import { mapGetters } from 'vuex';

export default {
  name: 'HMTipButton',
  props: {
    color: {
      type: String,
      default: 'brand',
    },
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      currency: 'studio/currency',
    }),
  },
  methods: {
    openTipModal() {
      this.$modal.show(TipJarModal, {
        studioName: this.studio.studio_name,
        currency: this.currency,
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';
.brand {
  color: $white;
}
.outline-gray {
  color: var(--brand-color, $coral);
}
</style>
